import {iniciarRequisicao, logout} from "../../helpers";
import api from "../api";
import {STATUS_HTTP} from "../statusHTTP";

export const buscarHubsDistribuicao = async () => {
  const headers = iniciarRequisicao();
  const {data, status} = await api.get('drp/hubs', {headers}).catch(logout)

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.hubs;
}
